// extracted by mini-css-extract-plugin
export var cFalse = "form-multiple-choice-module--cFalse--c00d3";
export var cTrue = "form-multiple-choice-module--cTrue--ac444";
export var styles = "form-multiple-choice-module--styles--a7e76";